<template>
  <div>
    <a-table :data-source="dataSource" :columns="columns" :pagination="pagination?pagination:false" rowKey="id">
      <div slot="searchDropdown" style="padding: 8px" slot-scope="{ column }">
        <a-input :placeholder="`搜索${column.title}`" v-model="searchText[column.dataIndex]"
                 style="width: 188px; margin-bottom: 8px; display: block;"/>
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="handleSearch(searchText[column.dataIndex],column.dataIndex)">搜索
        </a-button>
        <a-button size="small" style="width: 90px" @click="handleReset(column.dataIndex)">重置</a-button>
      </div>
      <template :slot-scope="{item,index}" :slot="item.name" v-for="(item,index) in getColumnsSlot">
        <slot :row="dataSource[index]" :index="index" :name="item.name"></slot>
<!--        <p>{{dataSource[index]}}</p>-->
        <p>{{ item }}</p>
        <p>{{ index }}</p>
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  name: "c-table-base",
  props: {

    dataSource: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => null
    },
    searchText: {
      type: Object,
      default: () => new Object()
    },
    search: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    return {}
  },
  computed: {
    // 遍历使用插槽的列
    getColumnsSlot() {
      let slots = []
      for (const column of this.columns) {
        let scopedSlots = column.scopedSlots
        if (scopedSlots) {
          let slotName = scopedSlots.customRender
          if (scopedSlots.customRender) {
            slots.push({name: slotName})
          }
        }
      }
      return slots
    },
  },
  mounted() {
    // console.log('6666--------------->', this.search)
  },
  methods: {
    handleSearch() {
      this.$emit('search')
    },
    handleReset(index) {
      this.searchText[index] = ''
    },
  }
}
</script>

<style scoped>

</style>
